import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
const MASK = '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022';
export function SecretWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    // In edit mode (field.value falsy or dirty=false), show masked placeholder;
    // the user must type to overwrite. SecretWidget always stores the typed value;
    // pruneUntouchedSecrets drops it if not dirty.
    const isDirty = fieldState.isDirty;
    const placeholder = isDirty ? meta.placeholder : MASK;
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Input, { ...field, id: field.name, type: "password", value: field.value ?? '', placeholder: placeholder, autoComplete: "new-password", readOnly: readonly ?? meta.readonly, disabled: disabled }) }));
}
//# sourceMappingURL=secret.js.map